import {useReportPageAnalytics} from 'mkt-ssr/lib/page/initialize/useReportPageAnalytics';

// This component rolls up all of our "on page init" hooks and calls
// them before rendering the page proper. This is a component rather
// than a hook as the HOC return from createPage() is what actually
// provides a good portion of the context used here
export function PageInitializer() {
  useReportPageAnalytics();

  return null;
}
